import { createActions } from '@manager-base/app-base/config/data-access';
import { BASE_PATH_API } from '@manager-base/app-base/environment/paths/constants';

const propertyImagesBase = `${BASE_PATH_API}/properties/:entityId/images`;
const unitImagesBase = `${BASE_PATH_API}/units/:entityId/images`;
const imagesBase = `${BASE_PATH_API}/images`;

const actions = {
    saveUnitImage: {
        method: 'POST',
        url: unitImagesBase
    },
    getUnitImages: {
        method: 'GET',
        url: unitImagesBase,
        isArray: true
    },
    deleteUnitImage: {
        method: 'DELETE',
        url: `${unitImagesBase}/:imageId`
    },
    reorderUnitImages: {
        method: 'PUT',
        url: unitImagesBase
    },
    getPropertyImages: {
        method: 'GET',
        url: propertyImagesBase,
        isArray: true
    },
    reorderPropertyImages: {
        method: 'PUT',
        url: propertyImagesBase
    },
    savePropertyImage: {
        method: 'POST',
        url: propertyImagesBase
    },
    updateImage: {
        method: 'PUT',
        url: `${imagesBase}/:imageId`
    },
    deletePropertyImage: {
        method: 'DELETE',
        url: `${propertyImagesBase}/:imageId`
    },
};

export function PropertyImagesApi() {
    return createActions(actions);
}
